const connectionList = [
  {
    id: 311,
    name: 'John Paul',
    status: 'God is One',
    image: '/assets/images/dummy2.jpg',
    email: 'john.paul@ict.com',
    address: 'ABC house, Bikaner',
    designation: 'CEO',
  },
  {
    id: 312,
    name: 'Rahul Dravid',
    status: 'Keep Calm and Work Hard!',
    image: '/assets/images/dummy1.jpg',
    email: 'rahul.dravid@ict.com',
    address: 'CDE house, Bikaner',
    designation: 'React Developer',
  },
  {
    id: 313,
    name: 'Will Smith',
    status: 'Battery about to die',
    image: '/assets/images/dummy2.jpg',
    email: 'will.smith@ict.com',
    address: 'XYZ house, Bikaner',
    designation: 'Marketing Manager',
  },
];
export default connectionList;
